module.exports = __webpack_public_path__ + "static/media/OfAFeatherJacket.6f78f94c.jpg";